import { useCallback, useEffect } from 'react';
import { getUrnByViewerUrn } from '../models/modelManagement';
export function useHideElements({
  geometryLoaded,
  viewer,
  hideAllExceptElements
}) {
  const hideModelElements = useCallback(params => {
    const {
      geometryLoaded,
      hideAllExceptElements,
      viewer
    } = params;
    const elements = Object.entries(hideAllExceptElements).filter(([urn]) => geometryLoaded[urn]);
    const visibleModels = viewer.getVisibleModels();

    if (!elements.length) {
      visibleModels.forEach(model => model.visibilityManager.setNodeOff(1, false));
      return;
    }

    const notUsedModels = visibleModels.filter(model => !Object.keys(hideAllExceptElements).includes(getUrnByViewerUrn(model.getData().urn)));

    if (notUsedModels.length) {
      notUsedModels.forEach(model => model === null || model === void 0 ? void 0 : model.visibilityManager.setNodeOff(1, true));
    }

    elements.forEach(([urn, externalIds]) => {
      const model = visibleModels.find(model => getUrnByViewerUrn(model.getData().urn) === urn);
      const elementIdMap = geometryLoaded[urn];
      model === null || model === void 0 ? void 0 : model.visibilityManager.setNodeOff(1, true);
      externalIds.map(externalId => elementIdMap[externalId]).forEach(objId => {
        model === null || model === void 0 ? void 0 : model.visibilityManager.setNodeOff(objId, false);
      });
    });
  }, []);
  useEffect(() => {
    if (viewer && hideAllExceptElements && geometryLoaded) {
      hideModelElements({
        viewer: viewer,
        geometryLoaded,
        hideAllExceptElements
      });
    }
  }, [hideAllExceptElements, geometryLoaded, viewer, hideModelElements]);
}